export default "__VITE_ASSET__CJh1Bo22__"